import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';

const initialState = {
  numCollaborations: 40,
  numCertificates: 60000,
  partnersImages: [],
};

// ---------------------- ASYNC THUNKS ----------------------

export const getPartnersImage = createAsyncThunk(
  'loggedOutHome/getPartnersImage',
  async () => {
    const res = await requests.getHomePagePartnersImage();
    const body = await res.json();
    return { ok: res.ok, body };
  }
);

export const fetchHomePageInfo = createAsyncThunk(
  'loggedOutHome/fetchHomePageInfo',
  async () => {
    const res = await requests.getHomePageInfo();
    const body = await res.json();
    return { ok: res.ok, body };
  }
);

// ---------------------- SLICE ----------------------

export const loggedOutHomeSlice = createSlice({
  name: 'loggedOutHome',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPartnersImage.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.partnersImages = [...payload.body.images];
        }
      })
      .addCase(fetchHomePageInfo.fulfilled, (state, { payload }) => {
        if (payload.ok) {
          state.numCollaborations = payload.body.numCollaborations;
          state.numCertificates = payload.body.numCertificates;
        }
      });
  },
});

export default loggedOutHomeSlice.reducer;
